import React from 'react';
import { format } from 'date-fns';
import { Star } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

export const ReviewCard = ({ review }) => {
  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < rating ? 'star-filled' : 'star-empty'}`}
        fill={i < rating ? 'currentColor' : 'none'}
      />
    ));
  };

  return (
    <div className="border-b border-slate-100 pb-6 last:border-0" data-testid={`review-${review.review_id}`}>
      <div className="flex items-start gap-4">
        <Avatar className="h-12 w-12">
          <AvatarImage src={review.reviewer?.picture} />
          <AvatarFallback className="bg-slate-100 text-slate-600">
            {review.reviewer?.name?.charAt(0) || 'U'}
          </AvatarFallback>
        </Avatar>
        
        <div className="flex-1">
          <div className="flex items-center justify-between mb-1">
            <h4 className="font-semibold text-slate-900">{review.reviewer?.name || 'Anonymous'}</h4>
            <span className="text-sm text-slate-500">
              {format(new Date(review.created_at), 'MMM d, yyyy')}
            </span>
          </div>
          
          <div className="flex items-center gap-1 mb-2">
            {renderStars(review.rating)}
          </div>
          
          <p className="text-slate-600 leading-relaxed">{review.comment}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
